import cx from 'classnames'
import { type FC, type HTMLAttributes, useEffect, useRef } from 'react'

import { useToggle } from '@/hooks'
import css from './EllipsisLabelWithTitle.module.scss'

type Props = {
  children: string
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>

const EllipsisLabelWithTitle: FC<Props> = ({
  children,
  className,
  ...divProps
}) => {
  const [titleOverflowed, setTitleOverflowed] = useToggle()

  const titleRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!titleRef.current) {
      return
    }

    const clone = titleRef.current?.cloneNode(true) as HTMLElement
    clone.style.visibility = 'false'
    clone.style.display = 'inline'
    document.body.append(clone)

    if (
      titleRef.current.getBoundingClientRect().width <
      clone.getBoundingClientRect().width
    ) {
      setTitleOverflowed(true)
    }

    clone.remove()
  }, [children])

  return (
    <div
      ref={titleRef}
      className={cx(className, css.ellipsis)}
      title={titleOverflowed ? children : undefined}
      {...divProps}
    >
      {children}
    </div>
  )
}

export default EllipsisLabelWithTitle
